import { render, staticRenderFns } from "./coins.vue?vue&type=template&id=4472012c&scoped=true&"
import script from "./coins.vue?vue&type=script&lang=js&"
export * from "./coins.vue?vue&type=script&lang=js&"
import style0 from "./coins.vue?vue&type=style&index=0&lang=less&"
import style1 from "./coins.vue?vue&type=style&index=1&id=4472012c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472012c",
  null
  
)

export default component.exports